// src/components/common/ErrorDisplay.jsx
/**
 * ErrorDisplay Component
 * 
 * Reusable component that displays error messages with optional retry functionality.
 * Used to show user-friendly error states throughout the application.
 * 
 * Functions:
 * - onRetry: Optional callback function for retry button functionality
 */

import React from 'react';
import Button from './Button';

const ErrorDisplay = ({ 
  error, 
  onRetry, 
  title = "Error Loading Data",
  className = '' 
}) => {
  return (
    <div className={`space-y-6 ${className}`}>
      <div className="card">
        <div className="text-center">
          <h2 className="text-lg font-semibold text-red-600 mb-2">{title}</h2>
          <p className="text-gray-600 mb-4">{error}</p>
          {onRetry && (
            <Button onClick={onRetry}>Try Again</Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ErrorDisplay;